import styled from 'styled-components';

import { StaticContentSection } from '@/components/Base/StaticContent/StaticContent.styles';
import {
  colorBlack200,
  colorBlack900,
  colorGrey50,
  colorGrey100,
  fontFamilyPrimary,
  mediaQueryMobileLargeMin,
} from '@/styleUtils';

export const Wrapper = styled(StaticContentSection)`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media ${mediaQueryMobileLargeMin} {
    gap: 24px;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;

  @media ${mediaQueryMobileLargeMin} {
    overflow-x: hidden;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-radius: 12px;
  border: 1px solid ${colorGrey100};
  overflow: hidden;
  border-collapse: separate;
  border-spacing: 0;
`;

export const Thead = styled.thead`
  background-color: ${colorGrey50};
`;

export const Tr = styled.tr`
  display: flex;
  border: none;

  &:not(:last-child) {
    border-bottom: 1px solid ${colorGrey100};
  }

  td:first-child {
    font-weight: 700;
  }
`;

export const Th = styled.th`
  font: 400 13px/20px ${fontFamilyPrimary};
  border: none;
  padding: 12px 16px;
  min-height: 64px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  color: ${colorBlack200};
  border-bottom: 1px solid ${colorGrey100};
`;

export const Td = styled.td`
  font: 400 14px/24px ${fontFamilyPrimary};
  color: ${colorBlack900};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 16px;
`;
